import React from 'react'

import layoutStyles from '../../index.module.scss'

import styles from './index.module.scss'

import type { BaseLayoutProps } from '@/layouts/base'

import BaseLayout from '@/layouts/base'
import themeStyles from '@/pages/tad.ai/_styles/theme.module.scss'
import { InterFont } from '@/styles/next-font'
import figmaStyles from '@/pages/tad.ai/_styles/figma-theme.module.scss'
import { figmaTheme } from '@/pages/tad.ai/_styles/figma-theme'
import DynamicTipsModal from '@/pages/tad.ai/_blocks/Modals/dynamic'
import PublisherStructured from '@/components/Structured/PublisherStructured'
import FacebookPixel from '@/components/integrated/FacebookPixel'
import MicrosoftBing from '@/components/integrated/MicrosoftBing'
import antdStyles from '@/pages/tad.ai/_styles/antd.module.scss'


import { useMemo, useEffect } from 'react';
import { useOrigin } from '@/hooks/routes';
import { cls } from 'tagged-classnames-free';
/**
 * 站点根布局组件，无常规 UI 实现
 *
 * 包括：
 * - 样式主题加载
 * - seo 等 BaseLayout 支持的相关属性配置
 */
const RootLayout = (props: BaseLayoutProps) => {
  const { children, ...rest } = props

  const themeClassNames = useMemo(() => {
    return [
      InterFont.className,
      styles.theme,
      InterFont.variable,
      themeStyles.theme,
      figmaStyles.theme,
      layoutStyles.layout,
      antdStyles.antd,
    ].filter(Boolean)
  }, [])

  useEffect(() => {
    // 异步添加到全局样式中，使得挂载到 body 中的元素也能使用应用主题相关变量
    document.documentElement.classList.add(...themeClassNames)
  }, [themeClassNames])
  const [staticOrigin] = useOrigin()
  return (
    <>
      <PublisherStructured
        name={'Tad AI'}
        origin={staticOrigin}
        contactPoint={[
          {
            '@type': 'ContactPoint',
            'email': 'support@tad.ai',
            'contactType': 'Technical support',
          },
        ]}
        sameAs={[
          'https://x.com/TadAI_official',
          'https://www.facebook.com/tadaimusic',
          'https://www.tiktok.com/@tadai_official',
          'https://www.youtube.com/@TadAI-official',
          'https://www.instagram.com/tadai_official/',
        ]}
      />
      {/* <Tapfiliate id='50349-fc43e0' createOptions={{ integration: 'stripe' }} /> */}
      <BaseLayout
        progressColor={figmaTheme.primary.css}
        {...rest}
        className={cls`
          ${themeClassNames}
          ${rest.className}
        `}
      >
        {children}
        <DynamicTipsModal />
      </BaseLayout>
      <FacebookPixel ids={['894365859781820']} />
      <MicrosoftBing id={'343236371'} />
    </>
  )
}

export default RootLayout
